import { createModuleDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';
export const versionDefinitionV0 = createModuleDefinitionVersion({
    label: 'admin-trial-cart',
    description: 'Cart-like UI for trialling JSW &amp; Confluence admins.',
    status: 'active',
    channels: ['web', 'mobile', 'desktop'],
    fieldDefinitions: []
});
//# sourceMappingURL=version-definition.js.map